import {createContext, useEffect, useState} from 'react'


const authDefault = {
    isAuthenticated: false,
    dataUser: null
}


export const AuthContext = createContext<any>({
    authInfo: authDefault,
    setDataUser: (dataUser?: any) => {
    },
    loading: false,
    notiMessage: '',
    setNotiMessage: () => {}
})

const AuthContextProvider = ({children}) => {
    const [authInfo, setAuthInfo] = useState<any>(authDefault);
    const [loading, setLoading] = useState<any>(true);
    const [notiMessage, setNotiMessage] = useState<any>(null)
    // const [notiMessageInfo, setNotiMessageInfo] = useState<any>(null)
    useEffect(() => {
        try {
            const dataUserParse = localStorage.getItem("dataUser");
            if (dataUserParse) {
                const dataUserInitial = JSON.parse(dataUserParse);
                if (
                    dataUserInitial &&
                    typeof dataUserInitial === "object" &&
                    typeof dataUserInitial.token === "string" &&
                    dataUserInitial.token.trim() !== ""
                ) {
                    setAuthInfo({
                        isAuthenticated: true,
                        dataUser: dataUserInitial
                    })
                } else {
                    localStorage.removeItem("dataUser");
                    setAuthInfo({
                        isAuthenticated: false,
                        dataUser: null
                    })
                }
            } else {
                setAuthInfo({
                    isAuthenticated: false,
                    dataUser: null
                })
            }
        } catch (e) {
            localStorage.removeItem("dataUser");
            setAuthInfo({
                isAuthenticated: false,
                dataUser: null
            })
        }
        setLoading(false);
    }, [])

    const setDataUser = (dataUser) => {
        if (dataUser) {
            localStorage.setItem("dataUser", JSON.stringify(dataUser));
            setAuthInfo({
                isAuthenticated: true,
                dataUser: dataUser
            })
        } else {
            localStorage.removeItem("dataUser")
            setAuthInfo({
                isAuthenticated: false,
                dataUser: dataUser
            })
        }
    }

    const authContextData = {
        authInfo,
        loading,
        setDataUser,
        notiMessage,
        setNotiMessage,
        // notiMessageInfo,
        // setNotiMessageInfo
    }

    return (
        <AuthContext.Provider value={authContextData}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContextProvider
